import { render } from "./ProjectPage.vue?vue&type=template&id=19a30947&ts=true"
import script from "./ProjectPage.vue?vue&type=script&lang=ts"
export * from "./ProjectPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__